import React from 'react';
import { CheckIcon, CreditCardIcon, DownloadIcon, LockKeyholeIcon, PrinterIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { motion, useReducedMotion } from 'framer-motion';
import { CTAButton, Section } from './Shared';
import { KanjiBackdrop, Seal } from './Ornaments';
const benefits = [{
  icon: PrinterIcon,
  label: 'Listo para imprimir o usar en tablet durante la sesión'
}, {
  icon: LockKeyholeIcon,
  label: 'Pago seguro con Mercado Pago'
}, {
  icon: DownloadIcon,
  label: '100% PDF · Acceso inmediato'
}, {
  icon: ShieldCheckIcon,
  label: 'Garantía de 7 días sin preguntas'
}];
export function Pricing() {
  const reduceMotion = useReducedMotion();
  return <Section id="pricing" glow className="paper-card my-12 rounded-sm border border-brand-gold/50 shadow-[0_20px_55px_rgba(44,38,32,0.11)]" data-id="element-264" data-mp="20rjwo047xaw5">
      <KanjiBackdrop glyphs={['價', '值', '術', '道', '傳']} data-id="element-265" data-mp="3c93464ou000i" />
      <div className="mx-auto max-w-2xl text-center" data-id="element-266" data-mp="3canxxs3bnexb">
        <span className="inline-flex items-center gap-2 rounded-sm bg-brand-burgundy px-4 py-1.5 text-[11px] font-bold uppercase tracking-[0.16em] text-brand-paper" data-id="element-267" data-mp="3vyf7utymt42w">
          <ZapIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-268" data-mp="9sia62ka2p39" />
          Oferta de lanzamiento
        </span>
        <h2 className="mt-5 font-display text-3xl font-bold text-brand-ink md:text-5xl" data-id="element-269" data-mp="erv4t9he50ge">
          TU <span className="text-brand-burgundy" data-id="element-270" data-mp="3d9h8nhogug19">ATLAS ANCESTRAL</span>
        </h2>
        <p className="mt-3 text-sm text-brand-muted md:text-base" data-id="element-271" data-mp="3i81yqoa07jbz">
          El precio de lanzamiento cierra pronto. Después sube $25.000 ARS.
        </p>
      </div>

      <div className="mx-auto mt-9 max-w-2xl" data-id="element-272" data-mp="3n5tzm7smmfsb">
        <div className="rounded-sm border-2 border-brand-gold/60 bg-brand-paper p-5 shadow-[0_14px_40px_rgba(124,95,42,0.14)] md:p-7" data-id="element-273" data-mp="3rydd74rbdax4">
          <div className="flex items-start gap-3" data-id="element-274" data-mp="2uhobrc6a0ao9">
            <Seal characters="第一" className="h-10 w-10 text-[11px]" data-id="element-275" data-mp="2zhashvlbc91t" />
            <span className="pt-1 font-serif text-[11px] font-bold uppercase tracking-[0.14em] text-brand-goldDark md:text-xs" data-id="element-276" data-mp="2zfg6edyb2aw5">
              El sistema visual más completo de acupuntura clínica en español
            </span>
          </div>
          <div className="mt-5 flex flex-col justify-between gap-5 sm:flex-row sm:items-end" data-id="element-277" data-mp="3177j92xrnjia">
            <div data-id="element-278" data-mp="2w7utoafifyc0">
              <h3 className="font-serif text-xl font-bold text-brand-ink" data-id="element-279" data-mp="2w7bgt84pw04u">
                ATLAS ANCESTRAL DE ACUPUNTURA™
              </h3>
              <p className="mt-1 text-sm text-brand-muted" data-id="element-280" data-mp="28k38sifwmcz4">
                3 Tomos + 6 Bonos · 118 páginas + material completo
              </p>
              <p className="mt-3 max-w-lg text-sm font-medium leading-relaxed text-brand-forest" data-id="element-281" data-mp="2igpvzdvpdg4b">
                El pack visual más completo de acupuntura y digitopuntura clínica
                para terapeutas formados que quieren perfeccionar su práctica,
                reducir la improvisación y aplicar con la precisión y autoridad
                que sus pacientes merecen.
              </p>
            </div>
            <div className="shrink-0 text-left sm:text-right" data-id="element-282" data-mp="9c60av0wmw0">
              <p className="text-sm text-brand-muted line-through" data-id="element-283" data-mp="596zmm66nqkr">
                $95.000 ARS
              </p>
              <p className="font-serif text-3xl font-bold text-brand-burgundy" data-id="element-284" data-mp="3nfl9a8xf5edc">
                $27.990 ARS
              </p>
            </div>
          </div>
        </div>
        <motion.div animate={reduceMotion ? undefined : {
        y: [0, -2, 0]
      }} transition={{
        duration: 2.8,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="mt-6" data-id="element-285" data-mp="3rihwkcxwlynm">
          <CTAButton fullWidth className="py-5 md:text-xl" data-id="element-286" data-mp="e9d79rf79wc0">
            → QUIERO MI ATLAS ANCESTRAL $27.990
          </CTAButton>
        </motion.div>
        <ul className="mt-5 grid gap-2 sm:grid-cols-2" aria-label="Beneficios de compra" data-id="element-287" data-mp="11xmriowrmc11">
          {benefits.map(benefit => <li key={benefit.label} className="flex items-center gap-2 rounded-sm border border-brand-gold/35 bg-brand-paper px-3 py-3 text-[11px] font-semibold leading-tight text-brand-text md:text-xs" data-id="element-288" data-mp="3f8jto6qvg934">
              <CheckIcon className="h-4 w-4 shrink-0 text-brand-forest" aria-hidden="true" data-id="element-289" data-mp="35b5qv9xvfita" />
              <benefit.icon className="h-4 w-4 shrink-0 text-brand-goldDark" aria-hidden="true" data-id="element-290" data-mp="1svq5zfvys6a" />
              {benefit.label}
            </li>)}
        </ul>
        <p className="mt-4 text-center text-xs text-brand-muted" data-id="element-291" data-mp="3o75ds6bzrw60">
          <CreditCardIcon className="mr-1 inline h-3.5 w-3.5 text-brand-forest" data-id="element-292" data-mp="3k6v3ihh62jlc" />
          Mercado Pago | Tarjeta · Garantía de 7 días
        </p>
      </div>
    </Section>;
}